import { useState } from "react";
import FaqBg from "../../assets/images/faq-bg.png";
import RedBox1 from "../../assets/images/red-box-1.png";

const Faq = (props) => {
  const [faq] = useState([
    {
      tr: {
        question: "Digi-Call Nedir?",
        answer:
          "Digi-Call, Unilever dijital ekibi tarafından düzenlenen ilk dijital etkinliğidir.",
      },
      eng: {
        question: "What is Digi-Call?",
        answer:
          "  Digi-Call is the first digital landmark event organized by the Unilever digital team.",
      },
    },
    {
      tr: {
        question: "Kimler Başvurabilir?",
        answer:
          "Digi-Call'a 3., 4. sınıf lisans ve 1. sınıf lisansüstü öğrencileri ve yeni mezunlar başvurabilir.",
      },
      eng: {
        question: "Who can apply?",
        answer:
          "3rd, 4th year and 1st year graduate students and new graduates can apply to Digi-Call.",
      },
    },
    {
      tr: {
        question: "Day 1 Nedir?",
        answer:
          "Day 1, Unilever dijital ekibini tanımanızı sağlayacak bir canlı yayın etkinliğidir. 11 Mayıs'ta gerçekleştirilecek Day 1 herkese açık bir etkinliktir.",
      },
      eng: {
        question: "What is Day 1?",
        answer:
          "Day 1 is a live broadcast event that will allow you to get to know the Unilever digital team. Day 1 is open to everyone and will be held on May 11th.",
      },
    },
    {
      tr: {
        question: "Day 2 Nedir?",
        answer:
          "Day 2, başvurular arasından seçilen adayların davet edildiği bir vaka etkinliğidir. Online olarak 12 Mayıs’ta gerçekleştirilecektir.",
      },
      eng: {
        question: "What is Day 2?",
        answer:
          "Day 2 is a case event where selected candidates are invited. It will be held online on May 12nd.",
      },
    },
    {
      tr: {
        question: "Day 2 için seçilip seçilmediğimi ne zaman öğrenebilirim?",
        answer:
          "Day 2 katılımcılarına 5 Mayıs tarihinde telefon/mail yoluyla ulaşılacaktır.",
      },
      eng: {
        question: "When can I find out if I’ve been selected for Day 2?",
        answer: "Day 2 participants will be contacted on May 5th.",
      },
    },
    {
      tr: {
        question: "Etkinliğe bireysel mi yoksa grup olarak mı başvurmalıyım?",
        answer: (
          <span>
            Digi-Call’a ister bireysel ister grup olarak başvurabilirsiniz.{" "}
            <br />
            Grup başvurularında sadece 1 kişinin başvuru formunu grup adına
            doldurması yeterlidir.
          </span>
        ),
      },
      eng: {
        question: "Should I apply for the event individually or as a group?",
        answer:
          "Both individual and team applications are accepted for the event. For team applications, it is sufficient for only one person from the team members to fill in the necessary information and apply. Individual applications will be teamed up with the most suitable people after evaluation.",
      },
    },
    {
      tr: {
        question: "Başka bir sorum var, size nasıl ulaşabilirim?",
        answer: (
          <span>
            Sorularını{" "}
            <a
              className="hover:text-[#00D7C4]"
              href="https://www.instagram.com/unilevercareerstr/"
            >
              @unilevercareerstr
            </a>{" "}
            Instagram hesabından bize iletebilirsin.
          </span>
        ),
      },
      eng: {
        question: "I have another question, how can I reach you?",
        answer: (
          <span>
            You can direct your questions to{" "}
            <a
              className="hover:text-[#00D7C4]"
              href="https://www.instagram.com/unilevercareerstr/"
            >
              @unilevercareerstr
            </a>{" "}
            account on Instagram
          </span>
        ),
      },
    },
  ]);

  return (
    <section
      id={props.currentLang === "eng" ? "faq" : "sss"}
      className="w-full flex justify-center bg-[#7705BC] py-28 relative"
    >
      <div className="w-4/5 max-w-screen-xl space-y-10 z-[2]">
        <div>
          <h2
            data-aos="fade-down"
            className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] font-bold text-white text-center"
          >
            {props.currentLang === "eng"
              ? "FREQUENTLY ASKED QUESTIONS"
              : "SIKÇA SORULAN SORULAR"}
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row lg:space-x-5 space-y-5 lg:space-y-0 justify-center">
          <div className="w-full lg:w-1/2 space-y-5">
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[0].eng.question
                  : faq[0].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[0].eng.answer
                  : faq[0].tr.answer}
              </p>
            </div>
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[1].eng.question
                  : faq[1].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[1].eng.answer
                  : faq[1].tr.answer}
              </p>
            </div>
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[2].eng.question
                  : faq[2].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[2].eng.answer
                  : faq[2].tr.answer}
              </p>
            </div>
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[3].eng.question
                  : faq[3].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[3].eng.answer
                  : faq[3].tr.answer}
              </p>
            </div>
          </div>
          <div className="w-full lg:w-1/2 space-y-5">
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[4].eng.question
                  : faq[4].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[4].eng.answer
                  : faq[4].tr.answer}
              </p>
            </div>
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[5].eng.question
                  : faq[5].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[5].eng.answer
                  : faq[5].tr.answer}
              </p>
            </div>
            <div data-aos="fade-up" className="w-full">
              <h3 className="text-lg lg:text-2xl text-[#00D7C4] font-bold mb-2 lg:mb-3">
                {props.currentLang === "eng"
                  ? faq[6].eng.question
                  : faq[6].tr.question}
              </h3>
              <p className="text-sm lg:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? faq[6].eng.answer
                  : faq[6].tr.answer}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full -top-[20px] sm:-top-[60px] md:-top-[100px] lg:-top-[150px] xl-top-[190px] right-0 h-[500px] absolute overflow-hidden">
        <img
          className="w-1/2 md:w-3/5  absolute -right-10"
          src={FaqBg}
          alt="faq bg"
        />
      </div>
      <img
        className="w-[90px] sm:w-[170px] lg:w-[240px] absolute left-[10%] -top-12 sm:-top-20 lg:-top-32"
        src={RedBox1}
        alt="red box"
      />
    </section>
  );
};

export default Faq;
